<template>
     <section class="w-full">
        <div class="container mx-auto">
            <div class="detail-article-content-container my-20">
                <h1 class="article-title">{{slug.data.category.vch_title}}</h1>
				<div class="main-content post-content" v-html="slug.data.category.txt_content" data-aos="fade-up">
				</div>
			</div>
        </div>
    </section>
</template>

<script setup lang="ts">
    const websiteConfig = useState('websiteConfig');
    const route = useRoute()
    const url = useRequestURL()

    const page = websiteConfig.value.pages.filter((item) => {
        return item.vch_slug == route.params.slug
    })

    if(page.length == 0){
        throw createError({
            statusCode: 404,
            statusMessage: 'Page Not Found'
        })
    }

    let slug = reactive({data: {}})

    const slugApi = ssrContent({
      path: '/api/menu-detail',
      method: 'POST',
      body: {
        category_slug: route.params.slug
      }
    })

    const { data , error} = await useAsyncData(async () => {
      const [slugData] = await Promise.all([
        slugApi.loadApi()
      ])

      return {slugData}
    })

    if(error.value !== null)
      console.log(error.value)

    

    slug.data = data.value.slugData.data

    useHead({
      title: `${slug.data.category.vch_title} - Enervon`,
      link: [{ rel: 'canonical', href: `${url.origin}/${route.params.slug}` }],
      meta: [
        { name: 'description', content: `${slug.data.category.meta_desc}` },
        { name: 'og:title', content: `${slug.data.category.vch_title} - Enervon` },
        { name: 'og:description', content: `${slug.data.category.meta_desc}` },
      ]
    })

    useJsonld({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "Beranda",
                "item": `${url.origin}`
            },{
                "@type": "ListItem",
                "position": 2,
                "name": `${page[0].vch_title}`,
                "item": `${url.origin}/${page[0].vch_slug}`
            }]
    });
</script>
